<template>
    <v-btn @click="onClick" content="Media" v-tippy="{placement: 'left'}">
        <i class="material-symbols-outlined">home_storage</i>
    </v-btn>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters('Notifications', ['newCommentNotificationsOfProject'])
    },
    methods: {
        onClick() {
            this.$store.dispatch('UI/setRightColumn', 'project')
        },
    },
};
</script>

<style lang="scss" scoped>
.button-container {
    position: relative;
}
</style>
